import BackendService from 'BackendService';
import { v4 as uuidv4 } from 'uuid';
import Contact from '../../../models/Contact';
import {
  AdminAssistDraft,
  PreviewAssistTranscriptMessage,
} from './veraAdminChatAssistPromptSandboxUtils';

export function createTranscriptMessage(
  role: 'investor' | 'admin',
  text: string,
  selectedContact: Contact,
): PreviewAssistTranscriptMessage {
  return {
    id: uuidv4(),
    senderRole: role,
    senderName:
      role === 'investor'
        ? `${selectedContact.firstName} ${selectedContact.lastName}`.trim()
        : 'Fides Team',
    text,
    timestamp: new Date().toISOString(),
  };
}

export interface LoadedAdminAssistPrompts {
  coachingMarkdown: string;
  productionMarkdown: string;
  intentText: string;
  intentProductionText: string;
  groundingText: string;
  groundingProductionText: string;
  transcript: PreviewAssistTranscriptMessage[];
}

export async function loadInitialAdminAssistPrompts(
  draft: AdminAssistDraft | null,
): Promise<LoadedAdminAssistPrompts> {
  const [coaching, intent, grounding] = await Promise.all([
    new BackendService().getVeraAdminChatAssistPrompt(),
    new BackendService().getVeraAdminChatAssistIntentPrompt(),
    new BackendService().getVeraAdminChatAssistGroundingPrompt(),
  ]);

  const productionMarkdown = coaching.productionMarkdown ?? '';
  const coachingMarkdown = draft?.markdown ?? coaching.sandboxMarkdown ?? productionMarkdown;
  const intentProductionText = intent.productionText;
  const intentText =
    draft?.intentText ??
    (intent.sandboxSource === 'custom' ? intent.sandboxText : intent.productionText);
  const groundingProductionText = grounding.productionText;
  const groundingText = draft?.groundingText ?? groundingProductionText;

  return {
    coachingMarkdown,
    productionMarkdown,
    intentText,
    intentProductionText,
    groundingText,
    groundingProductionText,
    transcript: draft?.transcript ?? [],
  };
}
